import React, { Component } from 'react';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { PropTypes as PT } from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import { deleteDevice } from '../../utils/deviceUtils';
import browserInfo from '../../utils/browserUtils';
import Tooltip from '../Tooltip';
import './DeviceListItem.scss';

const messages = defineMessages({
  modify: {
    id: 'modify',
    defaultMessage: 'Modify'
  },
  deleteMessage: {
    id: 'deleteMessage',
    defaultMessage: 'Delete'
  },
  apiError: {
    id: 'apiError',
    defaultMessage: 'Unable to complete administrator action. Please retry.'
  }
});

let isMounted;

class DeviceListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apiError: null,
      showDeleteWarning: false,
      highlighted: false
    };
  }

  componentDidMount() {
    isMounted = true;
  }

  componentWillUnmount() {
    isMounted = false;
  }

  handleClickOutside() {
    this.setState({ highlighted: false, showDeleteWarning: false });
  }

  handleClick = (evt) => {
    if (browserInfo.isMobile) {
      if (!this.state.highlighted) {
        evt.preventDefault();
        this.setState({ highlighted: true });
      }
    }
  };

  handleMouseLeave = () => {
    this.setState({ showDeleteWarning: false });
  };

  renderAdminTools() {
    const { contact, intl, setNotification } = this.props;

    return (
      <div className="adminTools">
        <button
          className="icon icon-edit adminButton"
          onClick={() => {
            window.open(`/go_setup?serial=${contact.serial}`);
          }}
        >
          <Tooltip fixPosition location="top" label={intl.formatMessage(messages.modify)} />
        </button>
        {this.state.showDeleteWarning ?
          <div className="deleteConfirm">
            <div className="deleteSlider">
              <FormattedMessage
                id="deleteDoubleCheck"
                defaultMessage="Are you sure?"
              />
            </div>
            <button
              alt={intl.formatMessage(messages.deleteMessage)}
              className="confirmButton"
              onClick={() => {
                deleteDevice(contact.serial).then(() => {
                  if (isMounted) {
                    this.setState({ showDeleteWarning: false });
                  }
                  this.props.removeDeviceFromList(contact.serial);
                })
                .catch((e) => {
                  setNotification(intl.formatMessage(messages.apiError));
                  if (isMounted) {
                    this.setState({ apiError: e });
                  }
                });
              }}
            >
              <FormattedMessage
                id="deleteConfirm"
                defaultMessage="Delete"
              />
            </button>
          </div>
          :
          <button
            alt={intl.formatMessage(messages.deleteMessage)}
            className="icon icon-cancel adminButton"
            onClick={() => {
              this.setState({ showDeleteWarning: true });
            }}
          >
            <Tooltip fixPosition location="top" label={intl.formatMessage(messages.deleteMessage)} />
          </button>
        }
      </div>
    );
  }

  render() {
    const { isadmin, contact } = this.props;
    const contactRowClasses = [
      'contactRow',
      this.state.highlighted ? 'highlighted' : '',
      this.state.showDeleteWarning ? 'deleteWarning' : ''
    ].join(' ');

    return (
      <li
        className={contactRowClasses}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleClick}
      >
        <a className="deviceDescription" href={`${contact.host}/code`}>{contact.description}</a>
        {isadmin && this.renderAdminTools()}
      </li>
    );
  }
}

DeviceListItem.propTypes = {
  intl: PT.object,
  contact: PT.object,
  isadmin: PT.bool,
  removeDeviceFromList: PT.func,
  setNotification: PT.func,
};

export default injectIntl(onClickOutside(DeviceListItem));



// WEBPACK FOOTER //
// ./src/components/DeviceListItem/DeviceListItem.js